import { render } from "./Styleguide-EditFrame.vue?vue&type=template&id=b31e4108"
import script from "./Styleguide-EditFrame.vue?vue&type=script&lang=js"
export * from "./Styleguide-EditFrame.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__